import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Schema,
  Loader,
  Container,
  Header,
  Content,
  Checkbox,
  InputPicker,
  SelectPicker,
} from "rsuite";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { get } from "lodash/fp";
import { StringType } from "schema-typed";
import { UserServices } from "../../../core/services/UserServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { HelperServices } from "../../../core/services/HelperServices";
import { StoreServices } from "../../../core/services/StoreServices";
import { UserFields } from "./UserDataTypes";

import "./Users.css";
import {
  httpStatusArr,
  onOffArr,
  yesNoObj,
  messageTypeArr,
  roleObjArr,
} from "../../../core/config/AppConstants";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { useTranslation } from "react-i18next";
import { setUserImage } from "../../../redux/user";

const ViewUpdateProfile = () => {
  const { t } = useTranslation();
  const fromRef = useRef<any>();
  const [loader, setLoader] = useState<boolean>(false);
  const [viewUserDetail, setViewUserDetail] = useState<UserFields>();
  const [formData, setFormData] = useState<any>({});
  const [fileInfo, setFileInfo] = React.useState<any>("");
  const countries = useSelector((state: any) => state.country.data);
  const [stateList, setStateList] = useState([]);
  const [citiyList, setCityList] = useState([]);
  const [storeList, setStoreList] = useState<any>([]);
  const [currentStore, setCurrentStore] = useState<any>({});
  const userState = useSelector((state: any) => state.user);
  const dispatch = useDispatch();

  let formValueObj = {
    fname: "",
    lname: "",
    email: "",
    mobile: "",
    receive_notification: "",
    country_id: "",
    state_id: "",
    city_id: "",
    area_name: "",
    building: "",
    house_no: "",
    landmark: "",
    pincode: "",
    address_mobile: "",
    image: "",
  };

  const [initialFormValue, setInitialFormValue] = useState<any>(formValueObj);
  const navigate = useNavigate();
  // review comment:can these model be moved to a shared file so that it could also be used in different model too ? TP
  let modelObject = Schema.Model({
    fname: StringType().isRequired(
      t("REQUIRED", {
        field: t("FIRST_NAME").toLowerCase(),
      })
    ),
    lname: StringType().isRequired(
      t("REQUIRED", {
        field: t("LAST_NAME").toLowerCase(),
      })
    ),
    email: StringType().isRequired(
      t("REQUIRED", {
        field: t("EMAIL").toLowerCase(),
      })
    ),
    mobile: StringType()
      .isRequired(
        t("REQUIRED", {
          field: t("MOBILE").toLowerCase(),
        })
      )
      .pattern(
        /^\d{10}$/,
        t("VALID", {
          entity: t("MOBILE").toLowerCase(),
        })
      ),
    receive_notification: StringType(),
    area_name: StringType().isRequired(
      t("REQUIRED", {
        field: t("AREA").toLowerCase(),
      })
    ),
    building: StringType().isRequired(
      t("REQUIRED", {
        field: t("BUILDING").toLowerCase(),
      })
    ),
    house_no: StringType().isRequired(
      t("REQUIRED", {
        field: t("HOUSE_NO").toLowerCase(),
      })
    ),
    landmark: StringType(),
    pincode: StringType()
      .isRequired(
        t("REQUIRED", {
          field: t("PINCODE").toLowerCase(),
        })
      )
      .pattern(
        /^\d{6}$/,
        t("VALID", {
          field: t("PINCODE").toLowerCase(),
        })
      ),
    address_mobile: StringType().pattern(
      /^\d{10}$/,
      t("VALID", {
        entity: t("MOBILE").toLowerCase(),
      })
    ),
  });

  const [formModelObject, setFormModelObject] = useState<any>({
    ...modelObject,
  });

  const [customVaildator, setCustomValidator] = useState({
    fieldName: "",
    error: false,
    errorMsg: "",
  });

  async function getStateList(countryId: any) {
    try {
      setLoader(true);
      const stateRes = await HelperServices.getAllValidStates({
        country: countryId,
      });

      if (stateRes && stateRes.data && stateRes.data.data) {
        setLoader(false);
        setStateList(get("data.data", stateRes));
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  }

  async function getCities(stateId: any) {
    try {
      setLoader(true);
      const res = await HelperServices.getAllValidCities({ state: stateId });
      if (res && res.data && res.data.data) {
        setLoader(false);
        setCityList(res.data.data);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  }

  const setFormInitialValue = (formObj: any, data: any) => {
    let obj: any = {};
    //setting initial form value from different levels of user detail obj
    Object.keys(formValueObj).map((formKey: any) => {
      Object.keys(data).map((userKey: any) => {
        if (formKey === userKey) {
          obj[formKey] = data[formKey];
          setInitialFormValue({ ...obj });
        }
      });
    });
    Object.keys(formValueObj).map((formKey: any) => {
      Object.keys(data.addresses[0]).map((userKey: any) => {
        if (formKey === "building" && userKey === "building_name") {
          obj[formKey] = data.addresses[0]["building_name"];
        }
        if (formKey === userKey) {
          if (formKey === "mobile") {
            obj["address_mobile"] = data.addresses[0][formKey];
          } else {
            obj[formKey] = data.addresses[0][formKey];
          }
          setInitialFormValue({ ...obj });
        }
      });
    });
  };

  async function getViewUserDetail(id: number) {
    try {
      setLoader(true);
      const res = await UserServices.viewUser(id);
      setLoader(false);
      if (res && res.data && res.data.data) {
        setViewUserDetail({ ...res.data.data });
        setFormInitialValue(formValueObj, res.data.data);
      }
    } catch (error) {
      setLoader(false);
    }
  }

  async function getStores() {
    try {
      const res = await StoreServices.getStores();
      if (res && res.data && res.data.data && res.data.data.length) {
        setStoreList(res.data.data);
        res.data.data.map((store: any) => {
          if (store.id === viewUserDetail?.store_id) {
            setCurrentStore(store);
          } else {
            setCurrentStore({});
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    let userId = UtilityServices.getLoggedInUser("id");
    getViewUserDetail(userId);
  }, []);

  useEffect(() => {
    if (viewUserDetail?.addresses[0]) {
      let countryId = viewUserDetail.addresses[0].country_id;
      let stateId = viewUserDetail.addresses[0].state_id;
      Promise.all([
        getStateList(countryId),
        getCities(stateId),
        getStores(),
      ]).finally(() => {
        setLoader(false);
      });
    }
  }, [viewUserDetail]);

  function SelectorCountry() {
    return (
      <InputPicker
        labelKey="country_name"
        valueKey="id"
        onClean={(e: any) => {
          if (
            viewUserDetail &&
            viewUserDetail.addresses &&
            viewUserDetail.addresses[0]
          ) {
            let initVal: any = { ...initialFormValue };
            initVal.country_id = null;
            initVal.state_id = null;
            initVal.city_id = null;
            setInitialFormValue({ ...initVal });
            let obj = { ...customVaildator };
            obj.error = true;
            obj.fieldName = "country_id";
            obj.errorMsg = t("PLEASE_SELECT") + " " + t("COUNTRY");
            setCustomValidator({ ...obj });
          }
        }}
        onChange={() => {
          setStateList([]);
          setCityList([]);
          let obj = { ...customVaildator };
          obj.error = true;
          obj.fieldName = "state_id";
          obj.errorMsg = t("PLEASE_SELECT") + " " + t("STATE");
          setCustomValidator({ ...obj });
        }}
        onSelect={(value: Number, item: any) => {
          if (value) {
            if (
              viewUserDetail &&
              viewUserDetail.addresses &&
              viewUserDetail.addresses[0]
            ) {
              let initVal: any = { ...initialFormValue };
              initVal.country_id = value;
              initVal.state_id = null;
              initVal.city_id = null;
              setInitialFormValue({ ...initVal });
              getStateList(value);
            }
          }
        }}
        defaultValue={initialFormValue?.country_id}
        data={countries}
        style={{ width: 224 }}
      />
    );
  }

  function SelectorState() {
    return (
      <SelectPicker
        labelKey="state_name"
        valueKey="id"
        onClean={(e: any) => {
          if (
            viewUserDetail &&
            viewUserDetail.addresses &&
            viewUserDetail.addresses[0]
          ) {
            let initVal: any = { ...initialFormValue };
            initVal.state_id = null;
            initVal.city_id = null;
            setInitialFormValue({ ...initVal });
            let obj = { ...customVaildator };
            obj.error = true;
            obj.fieldName = "state_id";
            obj.errorMsg = t("PLEASE_SELECT") + " " + t("STATE");
            setCustomValidator({ ...obj });
          }
        }}
        onChange={() => {
          setCityList([]);
          let obj = { ...customVaildator };
          obj.error = true;
          obj.fieldName = "city_id";
          obj.errorMsg = t("PLEASE_SELECT") + " " + t("CITY");
          setCustomValidator({ ...obj });
        }}
        onSelect={(value, item) => {
          if (value) {
            let obj = { ...formData };
            if (
              viewUserDetail &&
              viewUserDetail.addresses &&
              viewUserDetail.addresses[0]
            ) {
              let initVal: any = { ...initialFormValue };
              initVal.state_id = value;
              initVal.city_id = null;
              setInitialFormValue({ ...initVal });
              getCities(value);
            }
          }
        }}
        defaultValue={initialFormValue?.state_id}
        data={stateList}
        style={{ width: 224 }}
      />
    );
  }

  function SelectorCity() {
    return (
      <SelectPicker
        labelKey="city_name"
        valueKey="id"
        onClean={() => {
          if (
            viewUserDetail &&
            viewUserDetail.addresses &&
            viewUserDetail.addresses[0]
          ) {
            let initVal: any = { ...initialFormValue };
            initVal.city_id = null;
            setInitialFormValue({ ...initVal });
            let obj = { ...customVaildator };
            obj.error = true;
            obj.fieldName = "city_id";
            obj.errorMsg = t("PLEASE_SELECT") + " " + t("CITY");
            setCustomValidator({ ...obj });
          }
        }}
        onSelect={(value, item) => {
          if (value) {
            if (
              viewUserDetail &&
              viewUserDetail.addresses &&
              viewUserDetail.addresses[0]
            ) {
              let initVal: any = { ...initialFormValue };
              initVal.city_id = value;
              setInitialFormValue({ ...initVal });
              let obj = { ...customVaildator };
              obj.error = false;
              obj.fieldName = "";
              obj.errorMsg = "";
              setCustomValidator({ ...obj });
            }
          }
        }}
        defaultValue={initialFormValue?.city_id}
        data={citiyList}
        style={{ width: 224 }}
      />
    );
  }

  async function uploadImgage(file: any) {
    try {
      let payload: any = new FormData();
      payload.append("image", file);
      const res = await UserServices.uploadImage(
        UtilityServices.getLoggedInUser("id"),
        payload
      );
      if (
        res &&
        res.data &&
        res.data.status === httpStatusArr.ok &&
        res.data.message
      ) {
        UtilityServices.showToaster({
          message: res?.data?.message,
        });
        const { small_image_url, large_image_url, image_url } = res?.data?.data;
        dispatch(setUserImage(small_image_url));
        let userDetails = UtilityServices.getLoggedInUserDetails();
        userDetails.small_image_url = small_image_url;
        userDetails.large_image_url = large_image_url;
        userDetails.image_url = image_url;
        UtilityServices.updateLoggedInUserDetails(userDetails);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  const handleSumit = () => {
    let obj: any = { ...formData };
    obj["receive_notification"] = initialFormValue["receive_notification"]
      ? initialFormValue["receive_notification"]
      : viewUserDetail?.receive_notification;
    if (initialFormValue["country_id"] === null) {
      setCustomValidator({
        fieldName: "country_id",
        error: true,
        errorMsg: t("PLEASE_SELECT") + " " + t("COUNTRY"),
      });
      return;
    }
    if (initialFormValue["state_id"] === null) {
      setCustomValidator({
        fieldName: "state_id",
        error: true,
        errorMsg: t("PLEASE_SELECT") + " " + t("STATE"),
      });
      return;
    }
    if (initialFormValue["city_id"] === null) {
      setCustomValidator({
        fieldName: "city_id",
        error: true,
        errorMsg: t("PLEASE_SELECT") + " " + t("CITY"),
      });
      return;
    }
    if (initialFormValue["country_id"]) {
      obj["country_id"] = initialFormValue["country_id"];
    }
    if (initialFormValue["state_id"]) {
      obj["state_id"] = initialFormValue["state_id"];
    }
    if (initialFormValue["city_id"]) {
      obj["city_id"] = initialFormValue["city_id"];
    }
    updateUserProfile(UtilityServices.getLoggedInUser("id"), obj);
  };

  async function updateUserProfile(id: any, payload: any) {
    try {
      setLoader(true);
      const res: any = await UserServices.updateUserProfile(id, payload);
      if (
        res &&
        res.data &&
        res.data.status === httpStatusArr.ok &&
        res.data.message
      ) {
        setViewUserDetail({ ...res.data.data });
        setFormInitialValue(formValueObj, res.data.data);
        setLoader(false);
        UtilityServices.showToaster({
          message: res.data.message,
        });
        navigate(ContentRoutes.DASHBOARD);
      }
    } catch (error: any) {
      setLoader(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  return (
    <div className="users users-profile ">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Container className="container">
        <Header>
          <>
            <h4 className="mb-3">
              {t("VIEW")} {t("PROFILE")}
            </h4>            
          </>
        </Header>
        <Content className="content">
        <div className="flex-item">
              <div className="d-flex usr-img">
                <div>
                  <img
                    className="usr-img-bx"
                    src={
                      userState.userImage
                        ? userState.userImage
                        : UtilityServices.getLoggedInUser("small_image_url")
                        ? UtilityServices.getLoggedInUser("small_image_url")
                        : UtilityServices.getLoggedInUser("user_default_image")
                    }
                    alt=""
                  />
                </div>
                <input
                  id="image-upload"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  onChange={(e: any) => {
                    uploadImgage(e.target.files[0]);
                  }}
                  style={{ display: "none" }}
                />
                <label className="usr-img-lbl" htmlFor="image-upload">
                  {" "}
                  {t("UPLOAD")} {t("IMAGE")}
                </label>
              </div>
            </div>
          {viewUserDetail ? (
            <Form
              className="profile-fields d-flex" 
              style={{justifyContent: "space-between", flexWrap: "wrap"}}
              ref={fromRef}
              model={formModelObject}
              formDefaultValue={initialFormValue}
              noValidate
              layout="inline"
              onSubmit={(e: any) => {
                if (e) {
                  handleSumit();
                }
              }}
              onChange={(data: any) => {
                if (data) {
                  setFormData({ ...data });
                }
              }}
              onReset={(data: any) => {
                setFormInitialValue(formValueObj, viewUserDetail);
                fromRef.current.reset();
                fromRef.current._reactInternals.child.stateNode.reset();
                fromRef.current.state.formValue = null;
                setFormInitialValue(formValueObj, viewUserDetail);
              }}
            >
              <Form.Group controlId="fname">
                <Form.ControlLabel>{t("FIRST_NAME")}</Form.ControlLabel>
                <Form.Control name="fname" type="text" autoComplete={"off"} />
              </Form.Group>
              <Form.Group controlId="lname">
                <Form.ControlLabel>{t("LAST_NAME")}</Form.ControlLabel>
                <Form.Control name="lname" type="text" autoComplete={"off"} />
              </Form.Group>
              <Form.Group controlId="email">
                <Form.ControlLabel>{t("EMAIL")}</Form.ControlLabel>
                <Form.Control name="email" type="email" autoComplete={"off"} />
              </Form.Group>
              <Form.Group controlId="mobile">
                <Form.ControlLabel>{t("MOBILE")}</Form.ControlLabel>
                <Form.Control name="mobile" type="text" autoComplete={"off"} />
              </Form.Group>
              <Form.Group controlId="username">
                <Form.ControlLabel>{t("USERNAME")}</Form.ControlLabel>
                <Form.Control
                  name="username"
                  type="text"
                  defaultValue={viewUserDetail?.username}
                  autoComplete={"off"}
                  readOnly
                  disabled={true}
                />
              </Form.Group>
              <Form.Group controlId="role_id">
                <Form.ControlLabel>{t("ROLE")} :</Form.ControlLabel>
                <Form.Control
                  name="role_id"
                  type="text"
                  defaultValue={viewUserDetail?.roles[0]?.label}
                  readOnly
                  disabled={true}
                />
              </Form.Group>
              {viewUserDetail?.roles[0]?.id &&
                viewUserDetail?.roles[0]?.id == roleObjArr.store_admin.id && (
                  <Form.Group controlId="store_name">
                    <Form.ControlLabel>
                      {t("STORE")} {t("NAME")} :
                    </Form.ControlLabel>
                    <Form.Control
                      name="store_name"
                      type="text"
                      defaultValue={viewUserDetail?.store?.store_name}
                      autoComplete={"off"}
                      readOnly
                      disabled={true}
                    />
                  </Form.Group>
                )}

              <Form.Group controlId="emp_code">
                <Form.ControlLabel>{t("EMPLOYEE_CODE")}</Form.ControlLabel>
                <Form.Control
                  name="emp_code"
                  type="text"
                  defaultValue={viewUserDetail?.emp_code}
                  autoComplete={"off"}
                  readOnly
                  disabled={true}
                />
              </Form.Group>
              <Form.Group controlId="designation">
                <Form.ControlLabel>{t("DESIGNATION")}</Form.ControlLabel>
                <Form.Control
                  name="designation"
                  type="text"
                  defaultValue={viewUserDetail?.designation}
                  autoComplete={"off"}
                  readOnly
                  disabled={true}
                />
              </Form.Group>
              <Form.Group controlId="receive_notification">
                <Form.ControlLabel>
                  {t("RECEIVE_NOTIFICATION")}
                </Form.ControlLabel>
                <Checkbox
                  name="receive_notification"
                  defaultChecked={
                    initialFormValue?.receive_notification === onOffArr.on
                      ? true
                      : false
                  }
                  onChange={(val: any) => {
                    let obj = { ...initialFormValue };
                    obj.receive_notification === onOffArr.on
                      ? (obj.receive_notification = onOffArr.off)
                      : (obj.receive_notification = onOffArr.on);
                    setInitialFormValue({ ...obj });
                  }}
                >
                  {initialFormValue?.receive_notification === onOffArr.on
                    ? yesNoObj.yes
                    : yesNoObj.no}
                </Checkbox>
              </Form.Group>
              <Form.Group controlId="country_id">
                <Form.ControlLabel>{t("COUNTRY")} :</Form.ControlLabel>
                <Form.Control accepter={SelectorCountry} name="country_id" />
                {customVaildator.fieldName === "country_id" &&
                  customVaildator.error && (
                    <div style={{ color: "red" }}>
                      {customVaildator.errorMsg}
                    </div>
                  )}
              </Form.Group>
              <Form.Group controlId="state_id">
                <Form.ControlLabel>{t("STATE")} :</Form.ControlLabel>
                <Form.Control accepter={SelectorState} name="state_id" />
                {customVaildator.fieldName === "state_id" &&
                  customVaildator.error && (
                    <div style={{ color: "red" }}>
                      {customVaildator.errorMsg}
                    </div>
                  )}
              </Form.Group>
              <Form.Group controlId="city_id">
                <Form.ControlLabel>{t("CITY")} :</Form.ControlLabel>
                <Form.Control accepter={SelectorCity} name="city_id" />
                {customVaildator.fieldName === "city_id" &&
                  customVaildator.error && (
                    <div style={{ color: "red" }}>
                      {customVaildator.errorMsg}
                    </div>
                  )}
              </Form.Group>
              <Form.Group controlId="area_name">
                <Form.ControlLabel>{t("AREA")}</Form.ControlLabel>
                <Form.Control
                  name="area_name"
                  type="text"
                  autoComplete={"off"}
                />
              </Form.Group>
              <Form.Group controlId="building">
                <Form.ControlLabel>{t("BUILDING")}</Form.ControlLabel>
                <Form.Control
                  name="building"
                  type="text"
                  autoComplete={"off"}
                />
              </Form.Group>
              <Form.Group controlId="house_no">
                <Form.ControlLabel>{t("HOUSE_NO")}</Form.ControlLabel>
                <Form.Control
                  name="house_no"
                  type="text"
                  autoComplete={"off"}
                />
              </Form.Group>
              <Form.Group controlId="landmark">
                <Form.ControlLabel>{t("LANDMARK")}</Form.ControlLabel>
                <Form.Control
                  name="landmark"
                  type="text"
                  autoComplete={"off"}
                />
              </Form.Group>
              <Form.Group controlId="pincode">
                <Form.ControlLabel>{t("PINCODE")}</Form.ControlLabel>
                <Form.Control name="pincode" type="text" autoComplete={"off"} />
              </Form.Group>
              <Form.Group controlId="address_mobile">
                <Form.ControlLabel>{t("ADDRESS_MOBILE")}</Form.ControlLabel>
                <Form.Control
                  name="address_mobile"
                  type="text"
                  autoComplete={"off"}
                />
              </Form.Group>
              <ButtonToolbar className="text-center" style={{width: "100%", justifyContent: "center"}}>
                <Button appearance="primary" type="submit">
                  {t("UPDATE")}
                </Button>
                <Button
                  type="reset"
                  onClick={(e: any) => {
                    setFormInitialValue(formValueObj, { ...viewUserDetail });
                    navigate(ContentRoutes.DASHBOARD);
                  }}
                  color="red"
                  appearance="primary"
                >
                  {t("CANCEL")}
                </Button>
              </ButtonToolbar>
            </Form>
          ) : null}
        </Content>
      </Container>
    </div>
  );
};

export default ViewUpdateProfile;
